<template>
  <div :class="[containerclass, 'maincolorpickercomponent']">
    <ul class="km__list--modules main-color" v-if="getColorGroupRepresentativePalettenEntries.length > 0">
      <li class="km__list__element--modules" v-if="hasNoColorOption==='true'"
          :class="[{ active:currentColorValueIntOrNONEstring ==='<none>'}, 'noColor']">
        <div class="km__button--color nocolor" @click="$emit('setColorNone')">
          <span class="km__textcolor--title">no color</span>
        </div>
      </li>
      <li class="km__list__element--modules"
          v-for="(mainColor, index) in getColorGroupRepresentativePalettenEntries"
          :key="mainColor.NameImWeb"
          :class="{ active:index === getCurrentActiveColorGroup }"
      >
        <div class="km__button--color" :class="{border:colorIsNearWhite(mainColor.RGBHex)}"
             :style="{ 'background-color': '#'+mainColor.RGBHex}"
             @click="$emit('setColor', mainColor)"
        >
          <span class="km__textcolor--title">{{ mainColor.NameImWeb }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {computed, nextTick, watch} from "vue";
import {KEYFRAMETARGETS, OPEN} from "@km/animations/animationFactory";
import gsap from "gsap";
import {getScrollValue} from "@km/mixins/scrollvalue";
import {ColorGroupSelectionFuncions} from "@km/components/color/ModuleColorColorGroupSelectionFunctions";
import type {PalettenClusterSorted} from "@k/js/databaseInterfaceClasses";

const withClassSelector = s => '.' + s;


function scrollToActiveColorAfterRepaint(containerClass) {
  nextTick().then(() => {
    gsap.to(withClassSelector(containerClass) + ' .km__list--modules.main-color', {
      duration: 0.4,
      scrollLeft: getScrollValue(withClassSelector(containerClass) + ' .active')
    })
  })
}

const props = defineProps<
    {
      currentColorValueIntOrNONEstring: string|number|null,
      currentpalette: string|undefined,
      palettenCluster: PalettenClusterSorted | null,
      containerclass: string,
      hasNoColorOption?: string,
      animationkeyframesgetter: {
          getterForWatch: () => KEYFRAMETARGETS,
          animation: (keyframe: KEYFRAMETARGETS) => void,
          keyframes: any
        }
    }
>()


watch(()=>props.currentColorValueIntOrNONEstring, () => {
  scrollToActiveColorAfterRepaint(props.containerclass)
});

watch(
    props.animationkeyframesgetter!.getterForWatch,
    (newState: KEYFRAMETARGETS) => {
      props.animationkeyframesgetter!.animation(props.animationkeyframesgetter!.keyframes.getTarget(newState));
      if (newState === OPEN) {
        scrollToActiveColorAfterRepaint(props.containerclass);
      }
    }
);

const getColorGroupRepresentativePalettenEntries = computed(() =>
    ColorGroupSelectionFuncions.getColorGroupRepresentativePalettenEntries(props.palettenCluster)
);
const getCurrentActiveColorGroup = computed(() => {
      let addedGroupIndexFromPrecedingPalettes = ColorGroupSelectionFuncions.getCurrentActiveColorGroup(
          props.currentColorValueIntOrNONEstring,
          props.palettenCluster,
          props.currentpalette
      );
      for (const palette in props.palettenCluster) {
        if (palette === props.currentpalette) {
          return addedGroupIndexFromPrecedingPalettes;
        }
        addedGroupIndexFromPrecedingPalettes += props.palettenCluster![palette].length;
      }
      return addedGroupIndexFromPrecedingPalettes;
    }
);
const colorIsNearWhite = (color) => {
  return ColorUtilsVue.colorHexIsNearWhite(color)
};

</script>


<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__color--shadegroup-selection, .maincolorpickercomponent {
  position: fixed;
  height: 105px;
  width: 100%;
  right: -100%;
  bottom: 92px;
  z-index: 999;
  overflow-y: hidden;
  opacity: 0;

  .km__list--modules {
    position: relative;
    overflow-x: scroll;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: row;
    padding-bottom: 115px;

    &.main-color {
      padding-top: 43px;
    }

    .km__list__element--modules {
      padding: 6px 7px;

      &.active {
        .km__button--color {
          &:after {
            content: '';
            position: absolute;
            top: -5px;
            left: -5px;
            width: calc(100% + 10px);
            height: calc(100% + 10px);
            border: 2px solid config.$color-blue;
          }
        }
      }

      .km__button--color {
        &.nocolor {
          background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0MCA0MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDAgNDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOiNBN0E4QUE7fQ0KPC9zdHlsZT4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0wLDB2NDBoNDBWMEgweiBNMTkuMywyMEwxLDM4LjJWMS43TDE5LjMsMjB6IE0xLjcsMWgzNi41TDIwLDE5LjNMMS43LDF6IE0yMCwyMC43TDM4LjMsMzlIMS43TDIwLDIwLjd6DQoJIE0yMC43LDIwTDM5LDEuN3YzNi42TDIwLjcsMjB6Ii8+DQo8L3N2Zz4NCg==);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 40px;
        }
      }
    }
  }
}

</style>
